var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, Fragment } from "react";
import { Link, Placeholder } from "@storybook/components";
import { jsx } from "@storybook/theming";
var ErrorBoundary = (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { hasError: false };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        return {
            hasError: true,
            error: error,
        };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, info) {
        console.group("An error occurred during rendering Addon panel of storybook-addon-designs");
        console.log("--- Error ---");
        console.error(error);
        console.log("--- React Component Stack ---");
        console.error(info.componentStack);
        console.groupEnd();
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            return (jsx(Placeholder, null,
                jsx(Fragment, null, "Failed to render addon UI"),
                jsx(Fragment, null,
                    jsx("p", null, "Sorry, this addon has crashed due to the below error has thrown during rendering the addon UI."),
                    jsx("pre", null, String(this.state.error)),
                    jsx("p", null,
                        "See console log for more details. To clear the error state, please reload the page.",
                        " ",
                        jsx(Link, { href: "https://github.com/pocka/storybook-addon-designs/issues/new?assignees=&labels=category%3A+bug&template=bug_report.yml", target: "_blank", rel: "noopener", withArrow: true, cancel: false }, "Bug report")))));
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(Component));
export { ErrorBoundary };
